import React from 'react';
import type { LeaveStatus } from '../../types/leave';
import { LEAVE_STATUS_LABELS } from '../../constants/leave';
import styles from './LeaveStatusBadge.module.scss';

type Props = {
  status: LeaveStatus | string,
};

const STATUS_CLASS: Record<string, string> = {
  pending: styles.pending,
  to_plan: styles.to_plan,
  approved: styles.approved,
  rejected: styles.rejected,
  cancelled: styles.cancelled,
};

const LeaveStatusBadge = ({ status }: Props) => {
  const mod = STATUS_CLASS[status] ?? styles.cancelled;

  return (
    <span className={`${styles.badge} ${mod}`}>
      {LEAVE_STATUS_LABELS[status as LeaveStatus] || status}
    </span>
  );
};

export default LeaveStatusBadge;
